import i18n from '@/utils/i18n';
const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  mobile: (state) => state.user.mobile,
  userId: (state) => state.user.userId,
  roles: (state) => state.user.roles,
  authList: (state) => state.user.authList,
  appId: (state) => state.user.appId,
  appName: (state) => state.user.appName,
  hotelList: (state) => state.user.hotelList,
  hotelCode: (state) => state.user.hotelCode,
  hotelName: (state) => state.user.hotelName,
  hotelLogo: (state) => state.user.hotelLogo,
  bookTypeList: (state) => state.user.bookTypeList,
  guestTypeList: (state) => state.user.guestTypeList,
  roomTypeList: (state) => state.user.roomTypeList,
  hotelFrom: (state) => state.user.hotelFrom,
  allData: (state) => state.user.allData,
  btnUrlStr: (state) => state.user.btnUrlStr,
  businessDay: (state) => state.user.businessDay,
  roleAuthList: (state) => state.user.roleAuthList,
  userType: (state) => state.user.userType,
  linkRoomInfo: (state) => state.app.linkRoomInfo,
  roomOrderStatusList: (state) => state.app.roomOrderStatusList,
  socketMessage: (state) => state.app.socketMessage,
  isNeedRefreshBusinessDay: (state) => state.app.isNeedRefreshBusinessDay,
  appIdKey: (state) => state.user.appIdKey,
  printSettings: (state) => state.user.printSettings,
  userShifts: (state) => state.user.userShifts,
  recruitScrollY: (state) => state.settings.recruitScrollY,
  isOrderNoticeOpen: (state) => state.user.isOrderNoticeOpen,
  isOrderCancelNoticeOpen: (state) => state.user.isOrderCancelNoticeOpen,
  isAllDayCheckoutOpen: (state) => state.user.isAllDayCheckoutOpen,
  isHourRoomCheckout: (state) => state.user.isHourRoomCheckout,
  nightAuditStatus: (state) => state.user.nightAuditStatus,
  shiftsList: (state) => state.user.shiftsList,
  showGlobalTip: (state) => state.user.showGlobalTip,
  reportAuth: (state) => state.user.reportAuth,
  reportAjaxStatus: (state) => state.user.reportAjaxStatus,
  isFinMenus: (state) => state.user.isFinMenus,
  isNightAuditGrayEnv: (state) => state.app.isNightAuditGrayEnv,
  serviveInfo: (state) => state.user.serviveInfo,
  printLoading: (state) => state.app.printLoading,
  aiNoticeUnread: (state) => state.app.aiNoticeUnread,
  isAiFloatSuppressed: (state) => Object.keys(state.app.aiFloatSuppressors).length > 0,
  roomType: (state) => state.roomType,
  language: (state) => state.app.language,
  dialingCodeList: state => state.dialingCode.dialingCodeList
};
export default getters;
